export const regiones = [
    "Arica y Parinacota", "Tarapacá", "Antofagasta", "Atacama", "Coquimbo", 
    "Valparaíso", "O'Higgins", "Maule", "Ñuble", "Biobío", "La Araucanía", 
    "Los Ríos", "Los Lagos", "Aysén", "Magallanes", "Metropolitana"
];

export const comunasSantiago = [
    "Santiago", "Puente Alto", "Maipú", "Las Condes", "La Florida", "Ñuñoa", 
    "Vitacura", "Macul", "San Miguel", "Recoleta", "Providencia", "Quilicura", 
    "La Pintana", "Pudahuel", "Estación Central", "Pedro Aguirre Cerda"
];
